import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

import CollapsibleContainer from './CollapsibleContainer';
import TableHeader from './TableHeader';
import { VenueRow } from './TableRow';

type Props = {
  venues: Venue[];
  selectedVenueIds: string[];
  onSelectRows: (venueId: string[]) => void;
  brandName?: string;
  isDownloading?: boolean;
};

const Root = styled.div`
  width: 100%;
  overflow: auto;
`;

const Table = ({ brandName, venues, selectedVenueIds = [], onSelectRows, isDownloading = false }: Props) => {
  const onChangeVenueCheckBox = (venueId: string, checked: boolean) => {
    if (checked) {
      onSelectRows([...selectedVenueIds, venueId]);
    } else {
      onSelectRows(selectedVenueIds.filter(id => venueId !== id));
    }
  };

  const selectAllVenues = () => {
    const allActiveVenueIds = venues.map(record => record.id);
    onSelectRows(allActiveVenueIds);
  };

  const deselectAllVenues = () => onSelectRows([]);

  const listVenues = useMemo(() => {
    const cloneVenues = [...venues];
    cloneVenues.sort(a => {
      if (a.status === 'VENUE_PUBLISHED') {
        return -1;
      }
      return 1;
    });
    return cloneVenues;
  }, [venues]);

  return (
    <Root>
      <CollapsibleContainer
        header={
          <TableHeader
            onCheck={selectAllVenues}
            onUncheck={deselectAllVenues}
            isCheckboxDisabled={isDownloading}
            brandName={brandName}
            numVenues={venues.length}
            numSelectedVenues={selectedVenueIds.length}
          />
        }
      >
        {listVenues.map(venue => (
          <VenueRow
            key={venue.id}
            venue={venue}
            checked={selectedVenueIds.includes(venue.id)}
            onChangeVenueCheckBox={onChangeVenueCheckBox}
            disabled={isDownloading}
          />
        ))}
      </CollapsibleContainer>
    </Root>
  );
};

export default Table;
